import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import PermissionsWrapper from '../../PermissionsWrapper';

import styles from '../table.module.css';
import { capitalize } from '../../../services/utils';

const TableRowActions = ( {
	actions = [],
	row
} ) => {
	const mapActions = useCallback( () => actions.map( action => {
		const handleClick = () => {
			action.action( row );
		};

		return (
			<PermissionsWrapper
				key={ action.text }
				permission={ action.permission }
			>
				<Button
					{ ...action.componentProps }
					disabled={ action.disable }
					icon={ action.icon }
					onClick={ handleClick }
					size="tiny"
					title={ capitalize( action.text ) }
				/>
			</PermissionsWrapper>
		);
	} ), [ actions, row ] );

	return (
		<div className={ styles.tableRowActions }>
			{ mapActions() }
		</div>
	);
};

TableRowActions.propTypes = {
	actions: PropTypes.arrayOf( PropTypes.shape( {
		action: PropTypes.oneOfType( [
			PropTypes.func,
			PropTypes.object
		] ),
		disable: PropTypes.bool,
		dropdown: PropTypes.bool,
		icon: PropTypes.string,
		permission: PropTypes.bool,
		text: PropTypes.string
	} ) ),
	row: PropTypes.object.isRequired
};

export default memo( TableRowActions );
